<template>
<router-view></router-view>
</template>

<script>
export default {
  name: 'Message'
};
</script>

<style lang="less" scoped>
</style>
